export const MISSING_TEXT_PLACEHOLDER = 'N/A'
export const CHAICE_FASTENER_SECTION_MAP = {
  ONE_BREAK: {
    1: '1',
    2: '1',
    3: '1',
    4: '2',
    5: '2',
    6: '2',
  },
  TWO_BREAK: {
    1: '1',
    2: '1',
    3: '1',
    4: '2',
    5: '2',
    6: '3',
    7: '2',
    8: '2',
  },
  THREE_BREAK: {
    1: '1',
    2: '1',
    3: '1',
    4: '2',
    5: '2',
    6: '3',
    7: '3',
    8: '4',
    9: '2',
    10: '2',
  },
}
export const CHAICE_FASTENER_PLACEMENT_NAME_MAP = {
  ONE_BREAK: {
    1: 'top',
    2: '',
    3: 'break',
    4: 'break',
    5: '',
    6: 'bottom',
  },
  TWO_BREAK: {
    1: 'top',
    2: '',
    3: 'break',
    4: 'break_top',
    5: 'break_bottom',
    6: 'break',
    7: '',
    8: 'bottom',
  },
  THREE_BREAK: {
    1: 'top',
    2: '',
    3: 'break',
    4: 'break_top',
    5: 'break_bottom',
    6: 'break_top',
    7: 'break_bottom',
    8: 'break',
    9: '',
    10: 'bottom',
  },
}
export const CHAICE_FASTENER_PLACEMENT_TYPE_MAP = {
  ONE_BREAK: {
    1: 'corner',
    2: 'side',
    3: '',
    4: '',
    5: 'side',
    6: 'corner',
  },
  TWO_BREAK: {
    1: 'corner',
    2: 'side',
    3: '',
    4: '',
    5: '',
    6: '',
    7: 'side',
    8: 'corner',
  },
  THREE_BREAK: {
    1: 'corner',
    2: 'side',
    3: '',
    4: '',
    5: '',
    6: '',
    7: '',
    8: '',
    9: 'side',
    10: 'corner',
  },
}
export const CHAICE_SHAPE_TYPES_IDS = {
  ONE_BREAK: ['737', '734'],
  TWO_BREAK: ['735', '738'],
  THREE_BREAK: ['736', '739'],
}
export const NUMBER_OF_DAYS_FOR_NEW_ITEM = 180
